// extracted by mini-css-extract-plugin
export default {"filterGroupLabel":"filterGroupLabel---mNHhL boxOffsetStartMedium---UiqYl hasDot---EXqbk focusDotPositionStart---uN_M7"};